import { IconProps } from "../../utils/global-types/global-types";

const UniversityIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_6715_91156)">
        <path d="M15.12 11.293V6.94l-.82.273v4.081a1.29 1.29 0 0 0-.878 1.222v2.196c0 .227.183.41.41.41h1.757a.41.41 0 0 0 .41-.41v-2.196a1.29 1.29 0 0 0-.878-1.222M8.61 8.85 4.637 7.523v2.794a.4.4 0 0 0 .12.29A5.96 5.96 0 0 0 9 12.366c1.603 0 3.11-.624 4.244-1.758a.4.4 0 0 0 .12-.29V7.524L9.389 8.85a1.23 1.23 0 0 1-.778 0"></path>
        <path d="M9 8.092a.4.4 0 0 0 .13-.02l6.59-2.197a.41.41 0 0 0 0-.779L9.13 2.9a.4.4 0 0 0-.26 0L2.28 5.096a.41.41 0 0 0 0 .779L8.87 8.07a.4.4 0 0 0 .13.021"></path>
      </g>
      <defs>
        <clipPath id="clip0_6715_91156">
          <path fill="#fff" d="M2 2h14v14H2z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default UniversityIcon;
